import { http } from '@/api/client';
import type {
  ConteggioNonLette,
  NotificaVista,
  Paginated,
  PreferenzaNotifica,
  PreferenzaRiepilogo,
} from '@evolfin/shared';

/** Chiamate API del mondo notifiche, in un posto solo (riuso campana + preferenze). */

export async function contaNonLette(): Promise<ConteggioNonLette> {
  const { data } = await http.get<ConteggioNonLette>('/api/notifiche/non-lette');
  return data;
}

export async function listaNotifiche(
  params: { page?: number; pageSize?: number; soloNonLette?: boolean } = {},
): Promise<Paginated<NotificaVista>> {
  const { data } = await http.get<Paginated<NotificaVista>>('/api/notifiche', { params });
  return data;
}

export async function segnaLetta(id: number): Promise<void> {
  await http.post(`/api/notifiche/${id}/letta`);
}

export async function segnaTutteLette(): Promise<void> {
  await http.post('/api/notifiche/lette');
}

export async function leggiPreferenze(): Promise<PreferenzaNotifica[]> {
  const { data } = await http.get<{ preferenze: PreferenzaNotifica[] }>(
    '/api/notifiche/preferenze',
  );
  return data.preferenze;
}

export async function salvaPreferenze(preferenze: PreferenzaNotifica[]): Promise<void> {
  await http.put('/api/notifiche/preferenze', { preferenze });
}

export async function leggiRiepilogo(): Promise<PreferenzaRiepilogo> {
  const { data } = await http.get<PreferenzaRiepilogo>('/api/notifiche/riepilogo');
  return data;
}

export async function salvaRiepilogo(dati: PreferenzaRiepilogo): Promise<PreferenzaRiepilogo> {
  const { data } = await http.put<PreferenzaRiepilogo>('/api/notifiche/riepilogo', dati);
  return data;
}

export async function anteprimaRiepilogo(): Promise<void> {
  await http.post('/api/notifiche/riepilogo/anteprima');
}
